var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.list),function(l){return _c('b-form-checkbox',{key:l.name,staticClass:"checkbox-blcok",attrs:{"value":l},on:{"change":_vm.changeSelect},model:{value:(_vm.select),callback:function ($$v) {_vm.select=$$v},expression:"select"}},[_c('p',{staticClass:"fz14 text-dark1"},[_vm._v(_vm._s(l.name))])])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }